/* Curafyt navigation 2026 (test) — behaviour for sections/sve-nav-header.liquid */
(function () {
  if (customElements.get('sve-nav')) return;
  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var STORE_KEY = 'sveNavAnimal';

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  class SveNav extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('.sve-nav__drawer');
      // Small round close (x) at the top of the language lists (Valerie 2026-10-20)
      var xTpl = this.querySelector('.sve-nav__acct-menu .sve-nav__x');
      this.querySelectorAll('.sve-nav__flag .sve-mlang__list').forEach(function (list) {
        if (list.querySelector('.sve-nav__x')) return;
        var li = document.createElement('li'); li.className = 'sve-nav__xli';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sve-nav__x';
        b.setAttribute('aria-label', xTpl ? xTpl.dataset.xLabel : 'Close');
        b.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        li.appendChild(b); list.insertBefore(li, list.firstChild);
      });
      this.toggle = this.querySelector('.sve-nav__toggle');
      this.scrim = this.querySelector('.sve-nav__scrim');
      this.search = this.querySelector('.sve-nav__search');
      this.searchBtn = this.querySelector('.sve-nav__ic--search');
      this.acctBtn = this.querySelector('.sve-nav__acct-btn');
      this.acctMenu = this.querySelector('.sve-nav__acct-menu');
      this.tabs = Array.from(this.querySelectorAll('.sve-nav__tab'));
      this.dbtns = Array.from(this.querySelectorAll('.sve-nav__dbtn'));
      this.mode = null;
      this.animal = this.initialAnimal();
      this.selectAnimal(this.animal, false);

      this.toggle && this.toggle.addEventListener('click', () => (this.isOpen() ? this.close() : this.openMobile()));
      this.dbtns.forEach((b) => b.addEventListener('click', () => {
        var m = b.dataset.open;
        if (this.isOpen() && this.mode === m) return this.close();
        this.openDesktop(m);
      }));
      this.tabs.forEach((t) => {
        t.addEventListener('click', () => this.selectAnimal(+t.dataset.animal, true));
        t.addEventListener('keydown', (e) => this.onTabKey(e));
      });
      this.addEventListener('click', (e) => {
        var g = e.target.closest('.sve-nav__goal');
        if (g) { this.closeSub(g.closest('.sve-nav__panel')); this.closeCol(g.closest('.sve-nav__panel')); this.toggleGoal(g); }
        var sb = e.target.closest('.sve-nav__subbtn');
        if (sb) this.toggleSub(sb);
        if (e.target.closest('.sve-nav__closebar, .sve-nav__closebar-m')) { this.close(); return; }
        var xb = e.target.closest('.sve-nav__x');
        if (xb) {
          e.preventDefault(); e.stopPropagation();
          var det = xb.closest('details');
          if (det) { det.removeAttribute('open'); var sm = det.querySelector('summary'); sm && sm.focus(); }
          else { this.toggleAcct(false); this.acctBtn && this.acctBtn.focus(); }
          return;
        }
        var cb = e.target.closest('[data-col]');
        if (cb) { e.preventDefault(); this.toggleCol(cb); }
        var bk = e.target.closest('.sve-nav__colback');
        if (bk) this.closeCol(bk.closest('.sve-nav__panel'));
      });
      this.scrim && this.scrim.addEventListener('click', () => this.close());
      this.searchBtn && this.searchBtn.addEventListener('click', (e) => { e.preventDefault(); this.toggleSearch(); });
      this.acctBtn && this.acctBtn.addEventListener('click', (e) => { e.stopPropagation(); this.toggleAcct(); });
      document.addEventListener('click', (e) => {
        if (this.acctMenu && !this.acctMenu.hidden && !e.target.closest('.sve-nav__acct')) this.toggleAcct(false);
        if (DESKTOP.matches && this.isOpen() && !this.contains(e.target)) this.close();
        var lang = this.querySelectorAll('details.sve-mlang[open]');
        lang.forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.acctMenu && !this.acctMenu.hidden) { this.toggleAcct(false); this.acctBtn.focus(); return; }
        if (this.search && !this.search.hidden) { this.toggleSearch(false); this.searchBtn.focus(); return; }
        if (this.isOpen()) {
          var back = DESKTOP.matches ? this.querySelector('.sve-nav__dbtn[aria-expanded="true"]') : this.toggle;
          this.close();
          back && back.focus();
        }
      });
      DESKTOP.addEventListener('change', () => this.close());
      // Products hidden per goal (section setting "goal_hide"), menu only.
      (this.dataset.goalHide || '').split(';').forEach((line) => {
        var parts = line.split(':');
        if (parts.length !== 2) return;
        var goal = ' ' + parts[0].trim() + ' ';
        parts[1].split(',').forEach((pid) => {
          this.querySelectorAll('.sve-nav__card[data-pid="' + pid.trim() + '"]').forEach((c) => {
            c.dataset.goals = c.dataset.goals.split(goal).join(' ');
          });
        });
      });
      // Extra products per goal (section setting "goal_extra"), on top of the goal collections.
      (this.dataset.goalExtra || '').split(';').forEach((line) => {
        var parts = line.split(':');
        if (parts.length !== 2) return;
        var goal = parts[0].trim();
        parts[1].split(',').forEach((pid) => {
          this.querySelectorAll('.sve-nav__card[data-pid="' + pid.trim() + '"]').forEach((c) => {
            if (c.dataset.goals.indexOf(' ' + goal + ' ') < 0) c.dataset.goals += goal + ' ';
          });
        });
      });
      // Product order per row (section setting "row_order"): reorder the cards in the DOM.
      (this.dataset.rowOrder || '').split(';').forEach((line) => {
        var parts = line.split(':');
        if (parts.length !== 2) return;
        var ids = parts[1].split(',').map(function (x) { return x.trim(); });
        this.querySelectorAll('.sve-nav__rows [data-row="' + parts[0].trim() + '"] .sve-nav__cards').forEach(function (rail) {
          ids.slice().reverse().forEach(function (id) {
            var c = rail.querySelector(':scope > .sve-nav__card[data-pid="' + id + '"]');
            if (c) rail.prepend(c);
          });
        });
      });
      this.setupForms();
      this.setupModes();
      this.setupCart();
      this.setupClear();
      this.measure();
      window.addEventListener('resize', () => this.measure(), { passive: true });
      window.addEventListener('scroll', () => { if (this.isOpen()) this.measure(); }, { passive: true });
    }

    setupForms() {
      // Split product rows into form groups (section setting "form_groups"), e.g. Chews / Tabs / Powder / Liquid.
      var groups = [], labels = {};
      try { labels = JSON.parse(this.dataset.formLabels || '{}'); } catch (e) {}
      (this.dataset.formGroups || '').split(';').forEach(function (line) {
        var parts = line.split(':');
        if (parts.length === 2) groups.push({ key: parts[0].trim(), ids: parts[1].split(',').map(function (x) { return x.trim(); }) });
      });
      if (!groups.length) return;
      this.querySelectorAll('.sve-nav__rows .sve-nav__cards').forEach(function (rail) {
        var cards = Array.from(rail.querySelectorAll(':scope > .sve-nav__card'));
        var buckets = groups.map(function (g) { return cards.filter(function (c) { return g.ids.indexOf(c.dataset.pid) > -1; }); });
        if (buckets.filter(function (b) { return b.length; }).length < 2) return;
        var rest = cards.filter(function (c) { return !buckets.some(function (b) { return b.indexOf(c) > -1; }); });
        var wrap = document.createElement('div');
        wrap.className = 'sve-nav__forms';
        groups.forEach(function (g, i) {
          if (!buckets[i].length) return;
          var sub = document.createElement('div'); sub.className = 'sve-nav__tsub';
          var lbl = document.createElement('p'); lbl.className = 'sve-nav__tsub-lbl'; lbl.textContent = labels[g.key] || g.key;
          var r = document.createElement('div'); r.className = 'sve-nav__cards';
          buckets[i].forEach(function (c) { r.appendChild(c); });
          sub.appendChild(lbl); sub.appendChild(r); wrap.appendChild(sub);
        });
        if (rest.length) { var r2 = document.createElement('div'); r2.className = 'sve-nav__cards'; rest.forEach(function (c) { r2.appendChild(c); }); var s2 = document.createElement('div'); s2.className = 'sve-nav__tsub'; s2.appendChild(r2); wrap.appendChild(s2); }
        rail.replaceWith(wrap);
      });
    }

    setupModes() {
      // Mobile: switch per animal between "By goal" (the full menu, as before) and "By product type" (short list of the product rows) (Valerie 2026-10-28)
      var T = {
        en: ['By goal', 'By product type', 'All product types', 'products'],
        nl: ['Per doel', 'Per producttype', 'Alle producttypes', 'producten'],
        fr: ['Par objectif', 'Par type de produit', 'Tous les types de produits', 'produits'],
        de: ['Nach Ziel', 'Nach Produktart', 'Alle Produktarten', 'Produkte'],
        es: ['Por objetivo', 'Por tipo de producto', 'Todos los tipos de producto', 'productos'],
        it: ['Per obiettivo', 'Per tipo di prodotto', 'Tutti i tipi di prodotto', 'prodotti'],
        da: ['Efter mål', 'Efter produkttype', 'Alle produkttyper', 'produkter'],
        sv: ['Efter mål', 'Efter produkttyp', 'Alla produkttyper', 'produkter'],
        pl: ['Według celu', 'Według rodzaju produktu', 'Wszystkie rodzaje produktów', 'produkty']
      };
      var t = T[(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || T.en;
      var nav = this;
      var scrollTo = function (el) {
        var dr = nav.drawer, tabs = nav.querySelector('.sve-nav__tabs');
        if (!dr || !el) return;
        var top = dr.getBoundingClientRect().top + (tabs ? tabs.offsetHeight : 0) + 8;
        var goal = dr.scrollTop + el.getBoundingClientRect().top - top;
        if (goal < dr.scrollTop) dr.scrollTo({ top: goal });
      };
      this.querySelectorAll('.sve-nav__panel[data-panel^="animal-"]').forEach(function (panel) {
        var rows = Array.from(panel.querySelectorAll('.sve-nav__rows > .sve-nav__row'));
        var goals = panel.querySelector(':scope > .sve-nav__goals');
        if (rows.length < 2 || !goals || panel.querySelector('.sve-nav__mode')) return;
        var sw = document.createElement('div'); sw.className = 'sve-nav__mode'; sw.setAttribute('role', 'group');
        [['goal', t[0]], ['type', t[1]]].forEach(function (m, i) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'sve-nav__mode-b';
          b.dataset.mode = m[0]; b.textContent = m[1]; b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
          sw.appendChild(b);
        });
        var list = document.createElement('div'); list.className = 'sve-nav__types';
        var item = function (title, sub, imgs) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'sve-nav__type';
          var th = document.createElement('span'); th.className = 'sve-nav__type-th'; th.setAttribute('aria-hidden', 'true');
          imgs.slice(0, 2).forEach(function (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; th.appendChild(im); });
          var tx = document.createElement('span'); tx.className = 'sve-nav__type-tx';
          var h = document.createElement('span'); h.className = 'sve-nav__type-t'; h.textContent = title;
          var s = document.createElement('span'); s.className = 'sve-nav__type-s'; s.textContent = sub;
          tx.appendChild(h); if (sub) tx.appendChild(s);
          var go = document.createElement('span'); go.className = 'sve-nav__go'; go.setAttribute('aria-hidden', 'true'); go.textContent = '→';
          b.appendChild(th); b.appendChild(tx); b.appendChild(go);
          list.appendChild(b); return b;
        };
        var small = function (img) { return (img.getAttribute('src') || '').replace(/width=\d+/, 'width=160'); };
        rows.forEach(function (row) {
          var lbl = row.querySelector('.sve-nav__lbl'), all = row.querySelector('.sve-nav__all');
          var n = all && (all.textContent.match(/\((\d+)\)/) || [])[1];
          var forms = Array.from(row.querySelectorAll('.sve-nav__forms .sve-nav__tsub-lbl')).map(function (x) { return x.textContent.trim(); });
          var sub = forms.length ? forms.map(function (f, i) { return i ? f.toLowerCase() : f; }).join(', ') : (n ? n + ' ' + t[3] : '');
          // one product photo per card (skip the small goal icons)
          var imgs = Array.from(row.querySelectorAll('.sve-nav__card')).map(function (c) {
            var im = Array.from(c.querySelectorAll('img')).find(function (x) { return !/\.svg/i.test(x.getAttribute('src') || ''); });
            return im ? small(im) : '';
          }).filter(Boolean);
          var b = item(lbl ? lbl.textContent.trim() : '', sub, imgs);
          b.addEventListener('click', function () {
            rows.forEach(function (r) { r.classList.toggle('is-picked', r === row); });
            panel.classList.add('is-typepick');
            scrollTo(sw);
          });
        });
        var bun = panel.querySelector(':scope > .sve-nav__bundle');
        // skip Bundles when its collection is empty (e.g. dog bundles), so the list never leads to an empty page
        var bcv = bun && panel.querySelector('[data-colview="' + bun.dataset.col + '"] .sve-nav__all');
        if (bcv && /\(0\)/.test(bcv.textContent)) bun = null;
        if (bun) {
          var bt = bun.querySelector('b'), bs = bun.querySelector('small');
          var bb = item(bt ? bt.textContent.trim() : 'Bundles', bs ? bs.textContent.trim() : '', []);
          bb.classList.add('sve-nav__type--bundle');
          bb.addEventListener('click', function () { nav.toggleCol(bun); });
        }
        var back = document.createElement('button'); back.type = 'button'; back.className = 'sve-nav__typeback';
        back.textContent = '← ' + t[2];
        back.addEventListener('click', function () {
          panel.classList.remove('is-typepick');
          rows.forEach(function (r) { r.classList.remove('is-picked'); });
          scrollTo(sw);
        });
        panel.insertBefore(sw, goals);
        var quick = panel.querySelector(':scope > .sve-nav__quick');
        panel.insertBefore(list, quick || goals.nextSibling);
        var rowsWrap = panel.querySelector(':scope > .sve-nav__rows');
        rowsWrap && panel.insertBefore(back, rowsWrap);
        sw.addEventListener('click', function (e) {
          var b = e.target.closest('.sve-nav__mode-b');
          if (!b) return;
          var type = b.dataset.mode === 'type';
          sw.querySelectorAll('.sve-nav__mode-b').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          panel.querySelectorAll('.sve-nav__goal[aria-pressed="true"]').forEach(function (g) { nav.toggleGoal(g); });
          nav.closeCol(panel); nav.closeSub(panel);
          panel.classList.toggle('is-bytype', type);
          panel.classList.remove('is-typepick');
          rows.forEach(function (r) { r.classList.remove('is-picked'); });
          scrollTo(sw);
        });
      });
    }

    setupClear() {
      // Homepage: the bar floats over the hero (transparent) and turns solid once you scroll.
      if (!this.classList.contains('sve-nav--clear')) return;
      var wrap = this.closest('.shopify-section') || this.parentElement;
      var bar = this.querySelector('.sve-nav__bar');
      var fit = () => { wrap.style.marginBottom = -Math.round(bar.getBoundingClientRect().height) + 'px'; };
      var tick = () => { this.classList.toggle('is-solid', window.scrollY > 10); };
      fit(); tick();
      window.addEventListener('resize', fit, { passive: true });
      window.addEventListener('scroll', tick, { passive: true });
    }

    measure() {
      var r = this.querySelector('.sve-nav__bar').getBoundingClientRect();
      // mobile: the bar gets pinned to the top while open, so the drawer starts right under it
      var top = (!DESKTOP.matches) ? Math.round(r.height) : Math.max(0, Math.round(r.bottom));
      this.style.setProperty('--sn-top', top + 'px');
    }
    isOpen() { return !this.drawer.hidden; }

    initialAnimal() {
      // Open on the animal of the page you are on (product/collection in that animal's menu), else the last one used.
      var path = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
      var panels = Array.from(this.querySelectorAll('.sve-nav__panel'));
      if (/\/(products|collections)\//.test(path)) {
        for (var i = 0; i < panels.length; i++) {
          var hit = Array.from(panels[i].querySelectorAll('a[href]')).some(function (a) {
            return a.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '') === path;
          });
          if (hit) return i + 1;
        }
      }
      var s = +store(STORE_KEY);
      return s && s <= panels.length ? s : 1;
    }

    selectAnimal(n, remember) {
      this.animal = n;
      this.setAttribute('data-sel', n); // mobile Science / About us lists only show this animal's pages
      if (remember) store(STORE_KEY, String(n));
      this.tabs.forEach((t) => {
        var on = +t.dataset.animal === n;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
      });
      if (!DESKTOP.matches) this.showPanel('animal-' + n);
    }

    showPanel(id) {
      this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== id; });
    }

    onTabKey(e) {
      var i = this.tabs.indexOf(e.currentTarget), n = this.tabs.length, j = null;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      if (e.key === 'Home') j = 0;
      if (e.key === 'End') j = n - 1;
      if (j === null) return;
      e.preventDefault();
      this.selectAnimal(j + 1, true);
      this.tabs[j].focus();
    }

    openMobile() {
      this.toggleSearch(false); this.toggleAcct(false);
      this.measure();
      this.showPanel('animal-' + this.animal);
      this.drawer.hidden = false;
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-label', this.toggle.dataset.labelClose);
      document.documentElement.classList.add('sve-nav-lock', 'sve-nav-open');
      var sel = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      sel && sel.scrollIntoView && this.drawer.scrollTo(0, 0);
    }

    openDesktop(mode) {
      this.toggleSearch(false); this.toggleAcct(false);
      this.measure();
      this.mode = mode;
      if (mode.indexOf('animal-') === 0) this.selectAnimal(+mode.split('-')[1], true);
      this.showPanel(mode);
      this.drawer.hidden = false;
      this.scrim && (this.scrim.hidden = false);
      this.classList.add('is-open');
      document.documentElement.classList.add('sve-nav-open');
      this.dbtns.forEach((b) => b.setAttribute('aria-expanded', b.dataset.open === mode));
    }

    close() {
      this.drawer.hidden = true;
      this.scrim && (this.scrim.hidden = true);
      this.classList.remove('is-open');
      this.mode = null;
      this.dbtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.setAttribute('aria-label', this.toggle.dataset.labelOpen);
      }
      document.documentElement.classList.remove('sve-nav-lock', 'sve-nav-open');
    }

    toggleSub(btn) {
      // Advice / Reviews row: show its tiles on the right instead of the products (desktop)
      var panel = btn.closest('.sve-nav__panel');
      var on = btn.getAttribute('aria-pressed') !== 'true';
      this.closeSub(panel);
      if (!on) return;
      panel.querySelectorAll('.sve-nav__goal[aria-pressed="true"]').forEach((g) => this.toggleGoal(g));
      btn.setAttribute('aria-pressed', 'true');
      var view = panel.querySelector('[data-subview="' + btn.dataset.sub + '"]');
      if (view) view.hidden = false;
      panel.classList.add('has-sub');
    }

    toggleCol(btn) {
      // Bestsellers / Bundles: show that collection's products inside the menu instead of leaving it
      var panel = btn.closest('.sve-nav__panel');
      var on = btn.getAttribute('aria-pressed') !== 'true';
      this.closeCol(panel);
      if (!on) return;
      panel.querySelectorAll('.sve-nav__goal[aria-pressed="true"]').forEach((g) => this.toggleGoal(g));
      var view = panel.querySelector('[data-colview="' + btn.dataset.col + '"]');
      if (!view) { window.location.href = btn.href; return; }
      btn.setAttribute('aria-pressed', 'true');
      view.hidden = false;
      panel.classList.add('has-col');
      if (!DESKTOP.matches) view.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    closeCol(panel) {
      if (!panel) return;
      panel.querySelectorAll('[data-col]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      panel.querySelectorAll('.sve-nav__colview').forEach((v) => { v.hidden = true; });
      panel.classList.remove('has-col');
    }

    closeSub(panel) {
      if (!panel) return;
      panel.querySelectorAll('.sve-nav__subbtn').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      panel.querySelectorAll('.sve-nav__subview').forEach((v) => { v.hidden = true; });
      panel.classList.remove('has-sub');
    }

    toggleGoal(btn) {
      var panel = btn.closest('.sve-nav__panel');
      var on = btn.getAttribute('aria-pressed') !== 'true';
      panel.querySelectorAll('.sve-nav__goal').forEach((g) => g.setAttribute('aria-pressed', 'false'));
      var view = panel.querySelector('.sve-nav__goalview');
      if (!on) { panel.classList.remove('has-goal'); view.hidden = true; return; }
      btn.setAttribute('aria-pressed', 'true');
      var key = ' ' + btn.dataset.goal + ' ';
      var target = view.querySelector('.sve-nav__row--target');
      var shown = 0;
      target.querySelectorAll('.sve-nav__card').forEach((c) => {
        var hit = (c.dataset.goals || '').indexOf(key) > -1;
        c.classList.toggle('is-off', !hit);
        if (hit) shown++;
      });
      target.hidden = shown === 0;
      target.querySelectorAll('.sve-nav__tsub').forEach(function (sub) {
        sub.hidden = !sub.querySelector('.sve-nav__card:not(.is-off)');
      });
      // Optional per-goal order (section setting "goal_order"): listed products first, in that order.
      var order = [];
      (this.dataset.goalOrder || '').split(';').forEach(function (line) {
        var parts = line.split(':');
        if (parts.length === 2 && parts[0].trim() === btn.dataset.goal) order = parts[1].split(',').map(function (x) { return x.trim(); });
      });
      target.querySelectorAll('.sve-nav__card').forEach(function (c) {
        var i = order.indexOf(c.dataset.pid);
        c.style.order = i > -1 ? i : 100;
      });
      var whyEl = view.querySelector('script[data-why]'), why = {};
      try { why = JSON.parse(whyEl ? whyEl.textContent : '{}'); } catch (e) {}
      view.querySelectorAll('.sve-nav__card').forEach((c) => {
        // goal-specific line; on basis tiles it replaces the general label when there is one
        var w = c.querySelector('.sve-nav__card-why:not(.sve-nav__card-tag)');
        if (!w) return;
        var txt = why[btn.dataset.goal + '|' + c.dataset.pid] || '';
        w.textContent = txt; w.hidden = !txt;
        var tag = c.querySelector('.sve-nav__card-tag');
        if (tag) tag.hidden = !!txt;
      });
      var own = view.querySelector('[data-goal-all="' + btn.dataset.goal + '"]');
      view.querySelectorAll('[data-goal-all]').forEach((a) => {
        a.hidden = own ? a !== own : a.dataset.goalAll !== '*';
      });
      panel.classList.add('has-goal');
      view.hidden = false;
      // Mobile: glide down to the products of the chosen goal, so it is clear something happened (Valerie 2026-10-23)
      if (window.matchMedia('(max-width: 1023px)').matches) {
        var dr = this.querySelector('.sve-nav__drawer'), tabs = this.querySelector('.sve-nav__tabs');
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(function () {
          if (!dr) { view.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }); return; }
          // land just below the animal tabs, which stick to the top of the drawer while scrolling
          var top = dr.getBoundingClientRect().top + (tabs ? tabs.offsetHeight : 0) + 12;
          var start = dr.scrollTop, goal = start + view.getBoundingClientRect().top - top;
          dr.scrollTo({ top: goal, behavior: smooth ? 'smooth' : 'auto' });
          // some browsers ignore a smooth scroll while the drawer is still settling: then jump there
          setTimeout(function () { if (Math.abs(dr.scrollTop - start) < 2 && Math.abs(goal - start) > 2) dr.scrollTop = goal; }, 450);
        }, 30);
      }
    }

    toggleSearch(force) {
      if (!this.search) return;
      var show = force === undefined ? this.search.hidden : force;
      if (show) { this.close(); this.toggleAcct(false); }
      this.search.hidden = !show;
      this.classList.toggle('is-busy', !!show || (this.acctMenu && !this.acctMenu.hidden));
      this.searchBtn && this.searchBtn.setAttribute('aria-expanded', show);
      if (show) { var i = this.search.querySelector('input[type=search]'); i && i.focus(); }
      this.measure();
    }

    toggleAcct(force) {
      if (!this.acctMenu) return;
      var show = force === undefined ? this.acctMenu.hidden : force;
      if (show) { this.close(); this.toggleSearch(false); }
      this.acctMenu.hidden = !show;
      this.classList.toggle('is-busy', !!show || (this.search && !this.search.hidden));
      this.acctBtn.setAttribute('aria-expanded', show);
    }

    setupCart() {
      var link = this.querySelector('.sve-nav__ic--cart');
      var bubble = this.querySelector('[data-cart-count]');
      link && link.addEventListener('click', (e) => {
        // Open the theme's slide-out cart (lives in the hidden old header). It is loaded lazily on the
        // first 'init-run' event; trigger that if needed and fall back to the cart page after 3s.
        if (!(window.Alpine && Alpine.store && Alpine.store('xMiniCart'))) return;
        e.preventDefault();
        this.close();
        var href = link.href, t0 = Date.now();
        var open = function () {
          if (document.getElementById('CartDrawer')) { Alpine.store('xMiniCart').openCart(); return; }
          if (Date.now() - t0 > 3000) { location.href = href; return; }
          setTimeout(open, 100);
        };
        if (!document.getElementById('CartDrawer')) window.dispatchEvent(new CustomEvent('init-run'));
        open();
      });
      var set = function (n) {
        if (!bubble || typeof n !== 'number' || isNaN(n)) return;
        bubble.textContent = n > 99 ? '99+' : n;
        bubble.hidden = n === 0;
      };
      var refresh = function () {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { set(c.item_count); })
          .catch(function () {});
      };
      document.addEventListener('eurus:cart:items-changed', refresh);
      document.addEventListener('cart:updated', refresh);
      // The theme keeps the live count in its Alpine store after every add/change/remove: follow it
      // (skip the first run, which fires before the theme has read the cart).
      var watch = function () {
        if (!(window.Alpine && Alpine.effect && Alpine.store && Alpine.store('xCartHelper'))) return false;
        var first = true;
        Alpine.effect(function () {
          var n = Alpine.store('xCartHelper').currentItemCount;
          if (first) { first = false; return; }
          set(n);
        });
        return true;
      };
      if (!watch()) document.addEventListener('alpine:initialized', watch, { once: true });
    }
  }
  customElements.define('sve-nav', SveNav);
})();
